import { TranslateService } from '@ngx-translate/core';
import { EChartsOption } from 'echarts';

export interface GaugeChart {
  assetName: string;
  name: string;
  data: number;
  gaugeColor: string;
}

export function getGaugeChartOptions(
  data: GaugeChart[],
  translate: TranslateService
): EChartsOption[] {
  return data.map((chart) => getGaugeChart(chart, translate));
}

function getGaugeChart(data: GaugeChart, translate: TranslateService): EChartsOption {
  return {
    tooltip: {
      formatter: ({ value }: any) => {
        return `${data.assetName}<br>${translate.instant(data.name)}: ${value} %`;
      },
      confine: true,
    },
    series: [
      <any>{
        name: `${data.assetName}: ${translate.instant(data.name)}`,
        type: 'gauge',
        axisLine: {
          lineStyle: {
            color: [
              [0, data.gaugeColor],
              [1, data.gaugeColor],
            ],
            width: 10,
          },
        },
        itemStyle: { color: 'gray' },
        splitLine: {
          length: 10,
        },
        axisTick: { show: false },
        axisLabel: { show: false },
        data: [data.data],
      },
    ],
  };
}
